import { Grid, TextField } from '@material-ui/core'
import { DatePicker } from '@material-ui/pickers'

import { Controller } from 'react-hook-form'

import { Label } from 'components'

import helpers from 'helpers'
import preRegistrationConstants from 'constants/preRegistration'

const DateRangeFields = ({ paymentContract, control, disabled, errors }) => {
  const { DATE_RANGE_NOT_LINKED_OMIE_LABELS } = preRegistrationConstants

  return (
    <>
      {paymentContract?.codeContractOmie ? (
        <>
          <Grid item xs={12} sm={4}>
            <TextField
              disabled
              label="Data de inicio do contrato"
              fullWidth
              variant="outlined"
              defaultValue={helpers.formatters.date(
                paymentContract?.startDate || '-',
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controller
              as={
                <DatePicker
                  disabled={disabled}
                  label="Data de final do contrato *"
                  color="primary"
                  format="DD/MM/YYYY"
                  variant="dialog"
                  error={!!errors?.endDate}
                  helperText={errors?.endDate?.message}
                  fullWidth
                  onChange={(newValue) => ({ value: newValue })}
                />
              }
              control={control}
              name="endDate"
              mode="onChange"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              disabled
              label="Data da última renovação"
              fullWidth
              variant="outlined"
              defaultValue={
                paymentContract?.renewalDate
                  ? helpers.formatters.date(paymentContract?.renewalDate)
                  : 'Sem informação'
              }
            />
          </Grid>
        </>
      ) : (
        <>
          {DATE_RANGE_NOT_LINKED_OMIE_LABELS.map((label) => (
            <Grid item xs={12} sm={4}>
              <Label
                title={label}
                description="Disponível após vinculação com o OMIE"
              />
            </Grid>
          ))}
        </>
      )}
    </>
  )
}

export default DateRangeFields
